import React, { PureComponent } from "react";
import PageNotFound from "components/page-not-found";
import Page from "components/page";
import { connect } from "react-redux";
import { CollectionHeader } from "components/product-collection/collections-header";
import { DRIVE_LINK } from "containers/folders/utils/constants";
import PropTypes from "prop-types";

class MerchantIsDeactive extends PureComponent {
    static contextTypes = {
        me: PropTypes.object.isRequired,
    };

    render() {
        return (
            <Page viewport={this.props.app.viewport} hasPageHeader={false}>
                <CollectionHeader
                    me={this.context.me}
                    iconLink={this.context.me.hasCollectionsAccess() ? DRIVE_LINK : "/brands"}
                />
                <PageNotFound title="404" description="Merchant is Deactivated." />
            </Page>
        );
    }
}

const mapStateToProps = (state) => ({
    app: state.app,
});

export default connect(mapStateToProps)(MerchantIsDeactive);
